import { memo, useCallback, useState } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';

import { INSIGHT_SOURCES_PREVIEW } from '../../constants/intelligence.js';
import InsightSourceRow from './InsightSourceRow.jsx';

/**
 * The sources behind an insight (CT-5716): the first few, then "Show N more
 * sources" to list the rest. Showing more is local state: the detail already
 * carries every source.
 */
const InsightSources = memo(function InsightSources({ sources, onOpenInHistory }) {
  const { t } = useTranslation('unified-profiles');
  const [showAll, setShowAll] = useState(false);

  const showMore = useCallback(() => setShowAll(true), []);

  const visible = showAll ? sources : sources.slice(0, INSIGHT_SOURCES_PREVIEW);
  const hidden = sources.length - visible.length;

  return (
    <div className="flex flex-col gap-3">
      <ul className="flex flex-col gap-3">
        {visible.map((source) => (
          <InsightSourceRow key={source.id} source={source} onOpenInHistory={onOpenInHistory} />
        ))}
      </ul>
      {hidden > 0 ? (
        <div>
          <Button variant="ghost" size="sm" onClick={showMore}>
            {t('intelligence.insights.detail.showMoreSources', { count: hidden })}
          </Button>
        </div>
      ) : null}
    </div>
  );
});

export default InsightSources;
